<!-- メニュー -->
<app-menu></app-menu>

<!-- メイン -->
<div class="main">
  <!-- メインコンテンツ -->
  <div class="main-content" [class.platform-large-text]="getTextSize()">

    <div class="information-margin"></div>

    <!-- メッセージ -->
    <div class="message">
      <!-- メッセージ本文 -->
      <div class="message-text">
        <div class="p-d-flex p-jc-center">
          <i class="pi pi-check-circle" style="font-size: 6rem"></i><br />
        </div>
        <div class="message-margin"></div>
        <div class="p-d-flex p-jc-center">連携事例の登録完了</div>
      </div>
    </div>

    <!-- 本文 -->
    <div class="main-text">
      <p class="p-d-flex p-jc-left font-color">
        連携事例の登録をいたしました。
      </p>
      <p class="p-d-flex p-jc-left font-color">
        運営事務局にて承認後に一般公開となります。
      </p>
      <p class="p-d-flex p-jc-left font-color">
        内容について、運営事務局から直接、登録ご担当者様へeメール等での確認をさせていただく場合がございます。
      </p>
    </div>

    <!-- ボタンエリア -->
    <div class="p-d-flex p-jc-center button-area">
      <button
        pButton
        type="button"
        label="連携事例登録・管理へ"
        class="button-default-size button1"
        (click)="moveH104()"
      ></button>
    </div>
  </div>
</div>

<!-- フッダー -->
<footer>
  <app-footer></app-footer>
</footer>
